import { useState } from 'react';
import { useLazyMeasurementHistoryQuery } from '../../../graphql/graphql';

export default function useMeasurementHistory() {
	const [getMeasurementsQuery, { data, isLoading }] =
		useLazyMeasurementHistoryQuery();
	const [page, setPage] = useState(1);

	const getFlatMeasurementHistory = (filter: object) => {
		getMeasurementsQuery({
			where: filter,
			skip: (page - 1) * 20,
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return {
		getFlatMeasurementHistory,
		getNextPage,
		data,
		isLoading,
		page,
		setPage,
		settings: data?.wizardResults?.settings,
	};
}
